module.exports = __webpack_public_path__ + "static/york_main_6-ccf8e647d81d9b599693106f22a403e1.jpg";